var path = '/shared/javascripts/templates/chat_with_support_link/chat_with_support_link.html';
var html = "<a ng-click='startChat()' class=\"light-body--bold underline cursor-pointer\"\n  ng-class='{\"color-brandPrimary\": brandprimary}'>{{message}}</a>\n";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;